<div class="modal" *ngIf="roleToDetach">
    <div class="header">
        <h1 class="title" translate [translateParams]="{ name: roleToDetach.translatedName, username: memberDetails.username }">
            PREMIUM_TEAM_MODAL_DETACH_ROLE_FROM_MEMBER_QUESTION</h1>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <ng-container *ngIf="(detachRoleFromMemberPending$ | async); else notProcessing">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notProcessing>
            <div class='section'>
                <div class="description" translate>PREMIUM_TEAM_MEMBER_MODAL_DETACH_ROLE_FROM_MEMBER_QUESTION_CONFIRMATION</div>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()" [disabled]="(detachRoleFromMemberPending$ | async)"
            translate>PREMIUM_TEAM_MEMBER_MODAL_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="detachRoleFromMember()" [disabled]="(detachRoleFromMemberPending$ | async)"
            translate>PREMIUM_TEAM_MEMBER_MODAL_MODAL_DETACH_ROLE_FROM_GROUP_BUTTON_LABEL_DETACH_ROLE</button>
    </div>
</div>